import React from 'react';

// A very small, beginner‑friendly component.
// ▸ By default each column is the same width.
// ▸ Change widths with size1, size2, size3 props (they act like flex‑grow values).
function ThreeColumnRow({ size1 = 1, size2 = 1, size3 = 1, children = [] }) {
  const rowStyle = {
    display: 'flex',
    width: '100%',
  };

  return (
    <div style={rowStyle}>
      <div style={{ flex: size1 }}>{children[0] || 'Column 1'}</div>
      <div style={{ flex: size2 }}>{children[1] || 'Column 2'}</div>
      <div style={{ flex: size3 }}>{children[2] || 'Column 3'}</div>
    </div>
  );
}

export default ThreeColumnRow;
